import { Datepicker } from "Components/Form/Datepicker";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { useIsAkademikerneBranding } from "Store/partners/partnerHooks";
import { getError } from "Utils/productUtils";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";
import { startOfToday, subYears } from "date-fns";
import { FormikProps } from "formik";
import React from "react";
import { AkaCoInsuredValidAge } from "../../ProductPriceAka/AkaAdviceCards/akaAgeUtils";
import { AdviceProductDetailsFormValues } from "./interfaces";

interface Props {
  formProps: FormikProps<AdviceProductDetailsFormValues>;
}

export const CoInsuredFormElements = ({
  formProps,
}: Props): React.ReactElement | null => {
  const isAdvisor = useIsAdvisorSelector();
  const isAkaBranding = useIsAkademikerneBranding();
  const addCoInsuredToggle = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_754_AKA_ADVICE_ADD_CO_INSURED,
  );

  if (!isAkaBranding || !addCoInsuredToggle) {
    return null;
  }

  return (
    <>
      <RadioButtonTrueFalse
        name="addCoInsured"
        id="addCoInsured"
        label={"Ønsker du å legge til medforsikret?"}
        direction="vertical"
        error={getError("addCoInsured", formProps)}
      />
      {formProps.values.addCoInsured === BooleanFormType.TRUE && (
        <Datepicker
          id="coInsuredBirthDate"
          name="coInsuredBirthDate"
          label={"Fødselsdato til medforsikret"}
          max={startOfToday()}
          min={subYears(startOfToday(), AkaCoInsuredValidAge.SEVENTY)}
          error={getError("coInsuredBirthDate", formProps)}
          large
          inputProps={{ autoComplete: isAdvisor ? "off" : undefined }}
        />
      )}
    </>
  );
};
